import { Box, Button } from '@mui/material';
import useStyles from './styles';
import InvestmentDetails from './InvestmentDetails';
import { InvestmentDetails as InvestmentDetailsType } from 'hooks/data/investmentTransfer/useInvestmentTransfer';
import { dateToLabel } from 'further-ui/utils';
import { useFormContext } from 'react-hook-form';
import Heading from 'components/Heading';

type InvestmentsListProps = {
  investments: Array<InvestmentDetailsType>;
};

const hasLiveShareholdings = (investment: InvestmentDetailsType) =>
  !!investment.shareholdings.filter(
    (shareholding) => shareholding.noOfShare > 0,
  ).length;

const InvestmentsList: React.FC<InvestmentsListProps> = ({ investments }) => {
  const { classes } = useStyles();
  const { setValue } = useFormContext();

  const handleClearShares = (investment: InvestmentDetailsType) => {
    investment.shareholdings
      .filter((shareholding) => shareholding.noOfShare > 0)
      .forEach((shareholding) => {
        setValue(
          `sharesToTransfer[${investment.investmentId}][${shareholding.id}]`,
          0,
        );
      });
  };

  const handleSelectAllShares = (investment: InvestmentDetailsType) => {
    investment.shareholdings
      .filter((shareholding) => shareholding.noOfShare > 0)
      .forEach((shareholding) => {
        setValue(
          `sharesToTransfer[${investment.investmentId}][${shareholding.id}]`,
          shareholding.noOfShare,
        );
      });
  };

  return (
    <Box display="flex" flexDirection="column" gap="30px">
      {investments.filter(hasLiveShareholdings).map((investment) => (
        <div key={investment.investmentId} className={classes.tableHeader}>
          <Box className={classes.investmentHeader}>
            <Heading variant="h6">
              {investment.fundName} - {dateToLabel(investment.investmentDate)}
            </Heading>
            <Box display="flex" gap={16} className={classes.tableButtons}>
              <Button
                size="small"
                variant="outlined"
                color="primary"
                onClick={() => handleClearShares(investment)}
              >
                Clear all shares
              </Button>
              <Button
                size="small"
                variant="contained"
                color="primary"
                onClick={() => handleSelectAllShares(investment)}
              >
                Select all shares
              </Button>
            </Box>
          </Box>
          <InvestmentDetails investment={investment} />
        </div>
      ))}
    </Box>
  );
};

export default InvestmentsList;
